exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.canopy-list-renderer {\n  border: 1px solid #efefef;\n  border-radius: 10px;\n  padding: 20px;\n  background: white; }\n.canopy-list-renderer .renderer-title {\n    font-size: 18px; }\n.send-img-holder {\n  position: relative; }\n.send-img-holder .pen {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    position: absolute;\n    bottom: 0px;\n    left: 0px; }\n.send-img-holder.complete .pen {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    filter: alpha(opacity=100);\n    bottom: 60px;\n    left: 45px; }\n.count-display h3 {\n  font-size: 22px;\n  margin-right: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/send-to-studio-dialog/send-to-studio-dialog.component.scss
// module id = ../../../../../src/app/shared/components/send-to-studio-dialog/send-to-studio-dialog.component.scss
// module chunks = main